import {AppConfig} from './app-config.model';
import {InjectionToken, ValueProvider} from '@angular/core';

/**
 * A token used to inject the application configuration.
 *
 * @type {InjectionToken<AppConfig>}
 * @name APP_CONFIG
 * @description A token used to inject the application configuration.
 *
 */
export const APP_CONFIG = new InjectionToken<AppConfig>('enterwait.config');

/**
 * Provides a ValueProvider for the application configuration.
 *
 * This function takes an AppConfig object and returns a ValueProvider
 * that injects the given configuration as a value for the APP_CONFIG token.
 *
 * @param {AppConfig} value - The application configuration to be provided.
 * @returns {ValueProvider} A provider that supplies the given configuration value.
 */
export const provideAppConfig = (value: AppConfig): ValueProvider => ({
  provide: APP_CONFIG,
  useValue: value,
});
